<template>
  <div class="host">
    <b-pagination
      :value="value"
      @input="$emit('input', $event)"
      :total-rows="length"
      :per-page="pageSize"
      size="sm"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  props: {
    length: Number,
    pageSize: Number,
    value: Number
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #6280bd;

.host ul.pagination {
  margin: 0;
}
.host ::v-deep .page-item.active .page-link {
  background-color: $primary-color;
  border-color: $primary-color;
}
.host ::v-deep .page-link {
  color: $primary-color;
  outline: none;
  box-shadow: none;
}
</style>
